<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form class="rule-engine bg-gray-100 min-h-screen" [formGroup]="ruleSetForm">
  <div class="flex justify-end" *ngIf="canToggleEditing">
    <button
      nz-button
      nzType="primary"
      nzShape="round"
      *ngIf="isReadOnly"
      (click)="enableEditing()"
    >
      <i nz-icon nzType="edit"></i> Edit
    </button>
    <button
      nz-button
      nzType="default"
      nzShape="round"
      *ngIf="!isReadOnly"
      (click)="disableEditing()"
    >
      <i nz-icon nzType="cancel"></i> Cancel
    </button>
  </div>
  <!-- Rule -->
  <nz-card class="mb-3 bg-white shadow rounded" nzTitle="Rule">
    <div class="flex items-center gap-4">
      <div>
        <label class="font-semibold">Select Rule</label>
        <nz-select
          [(ngModel)]="selectedRuleId"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onRuleChange($event)"
          placeholder="Select a rule"
          style="width: 320px"
          [nzDisabled]="isReadOnly"
        >
          <nz-option
            *ngFor="let r of anyoRules"
            [nzValue]="r.value"
            [nzLabel]="r.data"
          ></nz-option>
        </nz-select>
      </div>
      <div>
        <label class="font-semibold">Internal Name</label>
        <input
          nz-input
          formControlName="name"
          placeholder="Internal name"
          style="width: 320px"
        />
      </div>
    </div>
  </nz-card>

  <!-- Applicable Attributes -->
  <nz-card class="mb-3 bg-white shadow rounded" nzTitle="Applicable Attributes">
    <div class="custom-table">
      <div class="custom-header">
        <div class="cell">Attribute</div>
        <div class="cell">Type</div>
      </div>

      <div class="custom-row" *ngFor="let attr of attributesFGs">
        <div class="cell">{{ attr.get("name")?.value }}</div>
        <div class="cell">{{ attr.get("type")?.value }}</div>
      </div>

      <div class="empty-row" *ngIf="!attributesFGs.length">
        No Data Available
      </div>
    </div>
  </nz-card>

  <!-- Conditions -->
  <nz-card class="mb-3 bg-white shadow rounded" nzTitle="Conditions">
    <div [formGroup]="conditionsRootFG">
      <ng-container
        *ngTemplateOutlet="groupTpl; context: { group: conditionsRootFG }"
      ></ng-container>
    </div>
  </nz-card>

  <!-- Outcome -->
  <nz-card class="mb-3 bg-white shadow rounded" nzTitle="Outcome">
    <div [formGroup]="eventRootFG">
      <label class="font-semibold">Type</label>
      <input
        id="event-type"
        nz-input
        formControlName="type"
        placeholder="event type"
        aria-label="event type"
        class="mb-4"
      />

      <div
        *ngFor="let p of paramsFGs(); let pi = index"
        [formGroup]="p"
        class="flex gap-2 mb-2"
      >
        <input
          nz-input
          formControlName="key"
          placeholder="key"
          style="width: 160px"
          aria-label="param key"
        />
        <ng-container [ngSwitch]="p.get('key')?.value">
          <ng-container *ngSwitchCase="'eventCategoryIds'">
            <nz-select
              formControlName="value"
              nzMode="multiple"
              style="min-width: 260px"
              placeholder="Select categories"
            >
              <nz-option
                *ngFor="let opt of eventCategoryOptions"
                [nzValue]="opt.value"
                [nzLabel]="opt.data"
              ></nz-option>
            </nz-select>
          </ng-container>
          <ng-container *ngSwitchCase="'score'">
            <input
              nz-input
              type="number"
              formControlName="value"
              placeholder="score"
              style="width: 200px"
              aria-label="score"
            />
          </ng-container>
          <ng-container *ngSwitchCase="'planId'">
            <nz-select
              formControlName="value"
              style="min-width: 260px"
              placeholder="Select plan"
            >
              <nz-option
                *ngFor="let opt of therapyPlanOptions"
                [nzValue]="opt.value"
                [nzLabel]="opt.data"
              ></nz-option>
            </nz-select>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <textarea
              nz-input
              formControlName="value"
              placeholder="value"
              nzAutosize
              style="width: 600px; min-height: 60px"
              aria-label="param value"
            ></textarea>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </nz-card>

  <nz-card class="mb-3 bg-white shadow rounded">
    <div class="flex items-center gap-2 mr-auto mb-2">
      <label class="font-semibold">Priority</label>
      <input
        nz-input
        type="number"
        formControlName="priority"
        placeholder="priority"
        style="width: 120px"
      />
    </div>
    <div class="flex items-center gap-2 mr-auto">
      <label class="font-semibold">Active</label>
      <nz-switch formControlName="active" />
    </div>
  </nz-card>
  <!-- Sticky Footer -->
  <div class="w-full flex justify-end pb-3 pr-5">
    <button
      type="button"
      nz-button
      nzType="primary"
      [disabled]="ruleSetForm.invalid"
      (click)="onSave()"
      *ngIf="!isReadOnly && !isForcedReadOnly"
    >
      <i nz-icon nzType="save"></i> Save
    </button>
  </div>

  <!-- Template for Groups -->
  <ng-template #groupTpl let-group="group">
    <div [formGroup]="group" class="p-3 border rounded bg-gray-50 mb-2">
      <div class="flex items-center gap-2 mb-2">
        <span class="font-semibold">Group</span>
        <nz-select
          formControlName="groupType"
          style="width: 120px"
          aria-label="group type"
        >
          <nz-option nzValue="all" nzLabel="all"></nz-option>
          <nz-option nzValue="any" nzLabel="any"></nz-option>
        </nz-select>
        <button
          nz-button
          nzType="dashed"
          nzShape="round"
          nzSize="small"
          (click)="addNestedGroup(childrenFA(group))"
          *ngIf="!isReadOnly"
        >
          <i nz-icon nzType="plus"></i> Add Group
        </button>
        <button
          nz-button
          nzType="dashed"
          nzShape="round"
          nzSize="small"
          (click)="addFactCondition(childrenFA(group))"
          *ngIf="!isReadOnly"
        >
          <i nz-icon nzType="plus-circle"></i> Add Fact
        </button>
      </div>

      <div class="ml-4">
        <div *ngFor="let child of childrenFA(group).controls; let ci = index">
          <ng-container *ngIf="isGroup(child); else factTpl">
            <nz-collapse>
              <nz-collapse-panel
                [nzHeader]="
                  (child.get('groupType')?.value || 'group') + ' group'
                "
              >
                <ng-container [formGroup]="asGroup(child)">
                  <ng-container
                    *ngTemplateOutlet="
                      groupTpl;
                      context: { group: asGroup(child) }
                    "
                  ></ng-container>
                </ng-container>
                <div class="mt-2">
                  <button
                    nz-button
                    nzType="text"
                    nzDanger
                    (click)="removeChild(childrenFA(group), ci)"
                    *ngIf="!isReadOnly"
                  >
                    <i nz-icon nzType="delete"></i> Remove Group
                  </button>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
          </ng-container>
          <ng-template #factTpl>
            <div
              [formGroup]="asGroup(child)"
              class="flex items-center gap-2 mb-2 bg-white p-2 rounded shadow-sm"
            >
              <nz-select
                formControlName="fact"
                placeholder="fact"
                style="width: 180px"
              >
                <nz-option
                  *ngFor="let a of attributesFA.value"
                  [nzValue]="a.name"
                  [nzLabel]="a.name"
                ></nz-option>
              </nz-select>
              <nz-select
                formControlName="operator"
                placeholder="operator"
                style="width: 180px"
              >
                <nz-option
                  *ngFor="let op of getOperatorsForChild(asGroup(child))"
                  [nzValue]="op"
                  [nzLabel]="op"
                ></nz-option>
              </nz-select>
              <ng-container [ngSwitch]="true">
                <ng-container
                  *ngSwitchCase="
                    (factOptionsByName[asGroup(child).get('fact')?.value] || [])
                      .length > 0
                  "
                >
                  <nz-select
                    formControlName="value"
                    [nzMode]="
                      attributeTypeByName[asGroup(child).get('fact')?.value] ===
                      'array'
                        ? 'multiple'
                        : 'default'
                    "
                    style="min-width: 220px"
                    placeholder="Select value"
                  >
                    <nz-option
                      *ngFor="
                        let opt of factOptionsByName[
                          asGroup(child).get('fact')?.value
                        ] || []
                      "
                      [nzValue]="opt.value"
                      [nzLabel]="opt.data"
                    ></nz-option>
                  </nz-select>
                </ng-container>
                <ng-container
                  *ngSwitchCase="
                    dataTypeByName[asGroup(child).get('fact')?.value] ===
                    'number'
                  "
                >
                  <input
                    nz-input
                    type="number"
                    formControlName="value"
                    placeholder="value"
                    style="width: 220px"
                  />
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <input
                    nz-input
                    formControlName="value"
                    placeholder="value"
                    style="width: 220px"
                    (blur)="normalizeValueInput(asGroup(child))"
                  />
                </ng-container>
              </ng-container>
              <button
                nz-button
                nzType="text"
                nzDanger
                (click)="removeChild(childrenFA(group), ci)"
                *ngIf="!isReadOnly"
              >
                <i nz-icon nzType="delete"></i> Remove Fact
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</form>
